import {redondear2, unoPorCiento, MONTO_MINIMO_UNO_POR_CIENTO} from './calculo-dte'

export {MONTO_MINIMO_UNO_POR_CIENTO}

export const aplicaUnoPorCiento = (sumaOperaciones: number): boolean =>
  redondear2(sumaOperaciones) >= MONTO_MINIMO_UNO_POR_CIENTO

export const percepcionUnoPorCiento = (
  aplica: boolean,
  sumaOperaciones: number,
  netoGravado: number,
  netoNoSujeto: number
): number =>
  aplica && aplicaUnoPorCiento(sumaOperaciones)
    ? unoPorCiento(redondear2(netoGravado)) + unoPorCiento(redondear2(netoNoSujeto))
    : 0

export const retencionUnoPorCiento = (aplica: boolean, sumaOperaciones: number, netoGravado: number): number =>
  aplica && aplicaUnoPorCiento(sumaOperaciones) ? unoPorCiento(redondear2(netoGravado)) : 0
